import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import CartItems from "./cartItems";
import { toast } from "react-toastify";

function ShopCart({ setCart }) {
  const { itemInCart } = useSelector((state) => state.cart);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);

  const handleWhatsAppOrder = () => {
    if (!itemInCart || itemInCart.length === 0) {
      toast.info("Корзина бош. Адегенде товар кошуңуз.");
      return;
    }

    const phoneNumber = "996559318110";
    let message =
      "Саламатсызбы! Мен төмөнкү товарларды заказ кылгым келет:\n\n";

    itemInCart.forEach((item, i) => {
      message += `${i + 1}. ${item.title} — ${item.quantity} даана × ${
        item.price
      } сом = ${item.price * item.quantity} сом\n`;
    });

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  const totalPrice =
    itemInCart?.reduce((sum, item) => sum + item.price * item.quantity, 0) || 0;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/40 z-40"
        onClick={() => setCart(false)}
      />

      {/* Cart */}
      <div className="fixed right-0 top-0 h-full w-full sm:w-[420px] bg-white z-50 shadow-xl flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-4 border-b">
          <h2 className="text-lg font-bold">Сиздин себет</h2>
          <button
            onClick={() => setCart(false)}
            className="text-2xl hover:text-red-600 transition"
          >
            <ion-icon name="close-outline"></ion-icon>
          </button>
        </div>

        {/* Items */}
        <div className="flex-1 overflow-y-auto px-4 py-4 space-y-4">
          {itemInCart && itemInCart.length > 0 ? (
            itemInCart.map((el) => <CartItems key={el.id} item={el} />)
          ) : (
            <p className="text-center text-gray-500 mt-20">Себет бош 🛒</p>
          )}
        </div>

        {/* Footer */}
        <div className="border-t px-4 py-4 space-y-4">
          <div className="flex justify-between text-lg font-semibold">
            <span>Жалпы сумма:</span>
            <span>{totalPrice} сом</span>
          </div>

          <button
            onClick={handleWhatsAppOrder}
            disabled={itemInCart.length === 0}
            className={`w-full py-3 rounded-lg font-semibold transition ${
              itemInCart.length === 0
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-[#A1C349] hover:bg-[#9ab556] text-white"
            }`}
          >
            WhatsApp аркылуу заказ берүү
          </button>
        </div>
      </div>
    </>
  );
}

export default ShopCart;
